import { createRoot, hydrateRoot } from 'react-dom/client';
import { IntakePage } from './intake/IntakePage';
import { localeFromLang } from './i18n/locale';
import { useDocumentMeta } from './i18n/meta';
import './styles/base.css';
import './styles/motion.css';
import './styles/layout.css';
import './intake/intake.css';

const locale = localeFromLang(document.documentElement.lang);
function App() { useDocumentMeta('intake', locale); return <IntakePage locale={locale} />; }
const root = document.getElementById('root')!;
if (root.firstElementChild) hydrateRoot(root, <App />); else createRoot(root).render(<App />);
